export default {
      id: "transaction-usage",
      viewBox: "0 0 43 39",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#transaction",
      toString: function () {
        return this.url;
      }
    }